import * as yup from "yup";
import { array, boolean, mixed, object, string } from "yup";

export const McpConnectionAuthModeSchema = mixed<
  "manual_bearer" | "oauth" | "none"
>()
  .oneOf(["manual_bearer", "oauth", "none"])
  .required();

export const McpConnectionPresetKeySchema = string().optional();

export const McpConnectionSchema = object({
  id: string().required(),
  name: string().required(),
  serverUrl: string().required(),
  enabled: boolean().required(),
  authMode: McpConnectionAuthModeSchema,
  scope: string().defined().default(""),
  expiresAt: string().nullable().default(null),
  createdAt: string().required(),
  updatedAt: string().required(),
  connected: boolean().required(),
  presetKey: McpConnectionPresetKeySchema,
});

export const McpConnectionsResponseSchema = object({
  connections: array().of(McpConnectionSchema).required(),
});

export const McpConnectionResponseSchema = object({
  connection: McpConnectionSchema.required(),
});

export const StartMcpOAuthResponseSchema = object({
  authUrl: string().required(),
  connectionId: string().required(),
});

export const McpConnectionActionResponseSchema = object({
  success: boolean().optional().default(false),
  message: string().optional(),
});

export const McpConnectionEnabledResponseSchema = object({
  success: boolean().required(),
  connection: object({
    id: string().required(),
    enabled: boolean().required(),
  })
    .nullable()
    .optional(),
});

export type McpConnection = yup.InferType<typeof McpConnectionSchema>;
export type McpConnectionsResponse = yup.InferType<
  typeof McpConnectionsResponseSchema
>;
export type StartMcpOAuthResponse = yup.InferType<
  typeof StartMcpOAuthResponseSchema
>;

export type McpConnectionEnabledResponse = yup.InferType<
  typeof McpConnectionEnabledResponseSchema
>;
